"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const THREE = __importStar(require("three"));
const lodash_1 = __importDefault(require("lodash"));
const applyRules_1 = __importDefault(require("../three/applyRules"));
const convertFaces_1 = __importDefault(require("../three/convertFaces"));
require("../three/enhancedOrbitControls");
const util_1 = require("../../data/util");
class FullScreenView extends React.Component {
    constructor(props) {
        super(props);
        this.resize = lodash_1.default.debounce(() => {
            this.resizeListener &&
                this.resizeListener(this.threeRootElement.offsetWidth, this.threeRootElement.offsetHeight);
        }, 100);
        this.keyDown = evt => {
            //console.log("kd, evt:", evt);
            switch (evt.key) {
                case "Escape":
                    this.props.escape();
            }
        };
        this.play = () => {
            this.setState({ playing: true });
            this.updateConfig && this.updateConfig({ iterationLimit: 1 });
            let i = 1;
            this.playInterval = setInterval(() => {
                i++;
                if (i <= this.state.iterationLimit) {
                    this.updateConfig && this.updateConfig({ iterationLimit: i });
                }
                else {
                    this.updateConfig && this.updateConfig({ iterationLimit: 1 });
                    i = 1;
                }
                this.setState({ frame: i });
            }, 1000);
        };
        this.stop = (forceUpdate = true) => {
            this.playInterval && clearInterval(this.playInterval);
            if (forceUpdate) {
                this.updateConfig &&
                    this.updateConfig({
                        iterationLimit: this.state.iterationLimit
                    });
                this.setState({ playing: false });
            }
        };
        this.state = {
            iterationLimit: props.defaultIterationLimit,
            playing: false,
            frame: 1
        };
    }
    render() {
        return (React.createElement("div", { ref: element => (this.threeRootElement = element), className: "three-full-container" },
            React.createElement("div", { className: "inset-buttons-left" },
                React.createElement("a", { className: "little-button", onClick: this.props.escape }, "Edit"),
                util_1.fromOneUpTo(this.props.defaultIterationLimit + 4).map(n => (React.createElement("a", { key: n, className: `little-button ${n === this.state.iterationLimit ? "active" : ""} ${this.state.playing && n === this.state.frame
                        ? "currentFrame"
                        : ""}`, onClick: () => {
                        //console.log("will call with", { iterationLimit: n });
                        this.updateConfig && this.updateConfig({ iterationLimit: n });
                        this.stop(false);
                        this.setState({ iterationLimit: n, playing: false });
                    } }, n))),
                this.state.playing ? (React.createElement("a", { className: "little-button", onClick: this.stop }, "Stop")) : (React.createElement("a", { className: "little-button", onClick: this.play }, "Play")),
                React.createElement("a", { className: "little-button", href: this.props.shareLink, target: "_blank" }, "Share"))));
    }
    componentDidMount() {
        this.resize();
        const { setSize, updateConfig } = this.threeEntry(this.threeRootElement);
        this.resizeListener = setSize;
        this.updateConfig = lodash_1.default.debounce(updateConfig, 50);
        window.addEventListener("resize", this.resize);
        this.updateConfig({ project: this.props.project });
        window.addEventListener("keydown", this.keyDown);
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.resize);
        window.removeEventListener("keydown", this.keyDown);
        this.controls && this.controls.dispose();
        this.playInterval && clearInterval(this.playInterval);
    }
    componentWillReceiveProps({ project }) {
        this.updateConfig && this.updateConfig({ project });
    }
    threeEntry(el) {
        let config = {
            iterationLimit: this.props.defaultIterationLimit
        };
        const scene = new THREE.Scene();
        const w = el.offsetWidth || 320;
        const h = el.offsetHeight || 240;
        const camera = new THREE.PerspectiveCamera(70, w / h, 0.1, 1000);
        camera.position.z = 4;
        this.controls = new THREE.EnhancedOrbitControls(camera);
        const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
        renderer.setSize(w, h);
        el.appendChild(renderer.domElement);
        // add things
        const ambientLight = new THREE.AmbientLight(0xffffff, 0.7);
        scene.add(ambientLight);
        const directionalLight = new THREE.DirectionalLight(0xffffff, 0.6);
        directionalLight.position.set(0, 1, 1);
        scene.add(directionalLight);
        let obj = null;
        const render = () => {
            requestAnimationFrame(render);
            this.controls.update();
            renderer.render(scene, camera);
        };
        render();
        return {
            setSize: (w, h) => {
                renderer.setSize(w, h);
                camera.aspect = w / h;
                camera.updateProjectionMatrix();
            },
            updateConfig: (args) => {
                //console.log("called update config", args);
                config = { ...config, ...args };
                if (config.project && config.iterationLimit) {
                    const faceSets = applyRules_1.default(config.project, config.iterationLimit);
                    if (obj !== null) {
                        scene.remove(obj);
                        obj = null;
                    }
                    obj = convertFaces_1.default(faceSets[config.iterationLimit - 1]);
                    scene.add(obj);
                }
            }
        };
    }
}
exports.default = FullScreenView;



// WEBPACK FOOTER //
// ./src/components/editor/FullScreenView.tsx